export const setPaidRecordsPagination = {
  SET_PAID_RECORDS_PAGINATION(state, payload) {
    state.paidRecordsPagination = payload;
  }
};
